import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=2163fe08&functional=true&"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=ts&"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports